import { RootState } from '@src/app/_redux';
import { CARE_TYPES } from '@src/app/_global/utility/constants';
import { CustomOrder } from '@CDSGlobal/gc-backend';

export const getAdminConfigTableItem = (
  adminConfig: any,
  clientConfig: any,
  tableName: string,
  overrideMagCode?: string,
): any => {
  let tableItem = {};
  let magCode = overrideMagCode
    ? overrideMagCode
    : clientConfig.clientConfig.magCode;

  if (adminConfig && adminConfig.adminConfig) {
    if (adminConfig.adminConfig[magCode]) {
      tableItem = adminConfig.adminConfig[magCode][tableName];
      if (
        Object.keys(tableItem).length === 0 &&
        tableItem.constructor === Object
      ) {
        tableItem = adminConfig.adminConfig['*'][tableName];
      }
    } else {
      if (adminConfig.adminConfig['*']) {
        tableItem = adminConfig.adminConfig['*'][tableName];
      }
    }
  }
  return tableItem;
};

export const buildEngageRedirectUrl = (
  availableActions: any,
  currentRecord: CustomOrder,
  billToAddress: any,
  jumpPageId: any,
): any => {
  if (!availableActions.Preferences) {
    return '';
  }
  // Need the base url and the remote login pageid at minimum.
  let redirectUrl = availableActions.Preferences.baseUrl;
  const remoteLoginPageId = availableActions.Preferences.remoteLoginPageId;
  let remoteLoginMagCode = availableActions.Preferences.remoteLoginMagCode;
  if (!redirectUrl || !remoteLoginPageId) {
    return '';
  }
  if (!remoteLoginMagCode) {
    remoteLoginMagCode = availableActions.ProdId;
  }
  if (redirectUrl.charAt(redirectUrl.length - 1) !== '/') {
    redirectUrl = redirectUrl + '/';
  }

  // Care Type (cdsCare or eCare)
  let careType = availableActions.Preferences.careType;
  if (careType === CARE_TYPES.ECARE) {
    redirectUrl = redirectUrl + 'servlet/ECareRemoteLoginGateway';
  } else {
    redirectUrl = redirectUrl + 'servlet/RemoteLoginGateway';
  }

  // mag code
  redirectUrl = redirectUrl + '?cds_mag_code=' + remoteLoginMagCode;

  // remote login page
  redirectUrl = redirectUrl + '&cds_page_id=' + remoteLoginPageId;

  // jump page (optional)
  if (jumpPageId) {
    redirectUrl = redirectUrl + '&cds_jump_page_id=' + jumpPageId;
  }

  // account number
  let accountNbr = '';
  if (currentRecord.isGift && currentRecord.isRecipient) {
    accountNbr = currentRecord.orderItems[0].shipToAccountNumber;
  } else {
    accountNbr = currentRecord.billToAccountNumber;
  }
  redirectUrl = redirectUrl + '&cds_account_number=' + accountNbr;

  // query type.  A = Account Number.  Z = Account/Zip (for eCare)
  let queryType = '';
  if (careType === CARE_TYPES.ECARE) {
    queryType = 'Z';
  } else {
    queryType = 'A';
  }
  redirectUrl = redirectUrl + '&cds_query_type=' + queryType;

  if (careType === CARE_TYPES.ECARE) {
    // zip code only for eCare logins
    redirectUrl = redirectUrl + '&cds_zip=' + billToAddress.postalCode;
  }

  // lookup type (single or multi)
  let lookupType = '';
  if (availableActions.Preferences.lookupType === 'multi') {
    lookupType = 'M';
  } else {
    lookupType = 'S';
  }
  redirectUrl = redirectUrl + '&cds_login_type=' + lookupType;

  // return url for error conditions
  if (availableActions.Preferences.returnUrl) {
    let returnUrl = availableActions.Preferences.returnUrl;
    if (!returnUrl.startsWith('http')) {
      returnUrl = window.location.origin + 
        (returnUrl.charAt(0) !== '/' ? '/' + returnUrl : returnUrl);
    }
    redirectUrl = redirectUrl + '&cds_return_url=' + returnUrl;
  }
  return redirectUrl;
};

export const getRenewPage = (availableActions: any): any => {
  let param = '';
  if (availableActions.Preferences && availableActions.Preferences.renewSubUrl) {
    param = availableActions.Preferences.renewSubUrl;
  }
  return param;
};

export const getRenewGiftPage = (availableActions: any): any => {
  let param = '';
  if (availableActions.Preferences && availableActions.Preferences.renewGiftUrl) {
    param = availableActions.Preferences.renewGiftUrl;
  }
  return param;
};

export const getPaymentPage = (availableActions: any, order: any): any => {
  let param = '';
  if ((order.isDonor || order.isRecipient) && availableActions.Preferences && availableActions.Preferences.makeGiftPaymentUrl) {
    param = availableActions.Preferences.makeGiftPaymentUrl;
  } else if (availableActions.Preferences && availableActions.Preferences.makePaymentUrl) {
    param = availableActions.Preferences.makePaymentUrl;
  }
  return param;
};

export const getEmailGiftCardPage = (availableActions: any): any => {
  let param = '';
  if (availableActions.Preferences && availableActions.Preferences.emailGiftCardUrl) {
    param = availableActions.Preferences.emailGiftCardUrl;
  }
  return param;
};